import { ILinkedWidget } from "../../models/ILinkedWidget";

export class WidgetsState {
  activeWidget: { [key: string]: string } = {};
  linkedSymbols: { link: string, symbol: string }[] = [];
  linkedWidgets: ILinkedWidget[] = [];
  symbols: { [key: string]: string[] } = {};
  detachedWindows: Window[] = [];
}
